export default "__VITE_ASSET__pM1kh9A8__"